"use client"

import * as React from 'react'
import { useRouter } from 'next/navigation'
import { CrudForm } from '@open-mercato/ui/backend/CrudForm'
import { flash } from '@open-mercato/ui/backend/FlashMessages'
import { Page, PageBody } from '@open-mercato/ui/backend/Page'
import { createCrud } from '@open-mercato/ui/backend/utils/crud'
import { useT } from '@open-mercato/shared/lib/i18n/context'
import {
  type ECmrFormValues,
  buildECmrFields,
  buildECmrFormSchema,
  buildECmrGroups,
  buildECmrPayload,
  buildInitialECmrValues,
} from '../../../lib/form'

export default function CreateECmrPage() {
  const t = useT()
  const router = useRouter()
  const fields = React.useMemo(() => buildECmrFields(t), [t])
  const groups = React.useMemo(() => buildECmrGroups(t), [t])
  const schema = React.useMemo(() => buildECmrFormSchema(t), [t])
  const initialValues = React.useMemo(() => buildInitialECmrValues(), [])

  return (
    <Page>
      <PageBody>
        <CrudForm<ECmrFormValues>
          title={t('ecmr.pages.create.title', 'Create eCMR')}
          backHref="/backend/ecmr"
          cancelHref="/backend/ecmr"
          submitLabel={t('ecmr.pages.create.submit', 'Create eCMR')}
          fields={fields}
          groups={groups}
          initialValues={initialValues}
          schema={schema}
          onSubmit={async (values) => {
            const created = await createCrud<{ id?: string }>('road/ecmr', buildECmrPayload(values), {
              errorMessage: t('ecmr.messages.createError', 'Failed to create eCMR.'),
            })
            flash(t('ecmr.messages.createSuccess', 'eCMR created.'), 'success')
            const id = created.result?.id
            router.push(id ? `/backend/ecmr/${id}` : '/backend/ecmr')
          }}
        />
      </PageBody>
    </Page>
  )
}
